"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Base = require("../common/Base");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["base", "platform", "interval", "packageName", "scope"];
/**
 * Npm Downloads
 *
 * `/npm/:interval/:packageName`
 * npm downloads: npm downloads per interval badge
 *
 * `/npm/:interval/:scope/:packageName`
 * npm downloads (scoped): npm downloads per interval (scoped version) badge
 *
 */
var Downloads = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$base = props.base,
    base = _props$base === void 0 ? 'https://img.shields.io' : _props$base,
    _props$platform = props.platform,
    platform = _props$platform === void 0 ? 'npm' : _props$platform,
    _props$interval = props.interval,
    interval = _props$interval === void 0 ? 'dm' : _props$interval,
    packageName = props.packageName,
    scope = props.scope,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var getUrl = function getUrl() {
    if (platform !== 'npm' || !packageName) return '';
    var url = [base, 'npm', interval];
    if (scope) {
      url.push(scope);
    }
    url.push(packageName);
    return url.join('/');
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Base.Internal, (0, _objectSpread2["default"])({
    imgSrc: getUrl(),
    ref: ref
  }, other));
});
Downloads.displayName = 'Downloads';
var _default = exports["default"] = Downloads;
module.exports = exports.default;